export function formatError(err: any, fallback = 'An unexpected error occurred'): string {
  if (!err) return fallback

  let result = fallback

  if (err.response) {
    const data = err.response.data
    const status = err.response.status

    if (data && typeof data === 'object' && data.message) {
      result = data.message
    }
    else if (typeof data === 'string' && data.trim().length > 0) {
      if (data.includes('<!DOCTYPE html>') || data.includes('<html')) {
        result = `Server error (${status}). Please try again later.`
      } else {
        result = data
      }
    }
    else {
      switch (status) {
        case 400: result = 'The request was invalid. Please check your input.'; break
        case 401: result = 'Your session has expired. Please log in again.'; break
        case 403: result = 'Access denied. You do not have permission for this.'; break
        case 404: result = 'The requested information could not be found.'; break
        case 409: result = 'Conflict detected. This account may already be linked or in use.'; break
        case 422: result = 'Validation failed. Please verify the provided details.'; break
        case 429: result = 'Too many attempts. Please wait a moment and try again.'; break
        case 500: result = 'A server error occurred. We are working to fix it.'; break
        case 504: result = 'The service is currently unavailable. Please check your connection.'; break
        default: result = `Error (${status}). ${fallback}`
      }
    }
  }
  else if (err.message && typeof err.message === 'string') {
    if (err.message === 'Network Error') {
      result = 'Network error. Please check your internet connection.'
    } else if (err.message.includes('timeout')) {
      result = 'The request timed out. Please try again.'
    } else {
      result = err.message
    }
  }

  else if (typeof err === 'string' && err.trim().length > 0) {
    result = err
  }

  return result.replace(/([.!?])\s+/g, '$1\n')
}
